<template>
    <div class="container">
        <div class="content">
            <el-card style="width:900px;margin:0 auto;margin-top:70px">
                <div slot="header" class="clearfix">
                    <span>违章处理</span>
                </div>
                <div style="text-align:center">
                    <img src="../assets/success.png" style="width:188px;margin-top:30px"/>
                    <p style="font-size:16px;margin-top:30px;margin-bottom:20px">
                        违章已提交处理
                        <span style="font-size:24px;color:#f40;font-weight:bold">{{$route.query.price ? $route.query.price: '' }}</span>
                        <span v-if="$route.query.price"> 元</span>
                    </p>
                    <p style="font-size:12px;color:#97A3B4">
                        违章将在2-5个工作日内处理完成。处理将通过APP或短信通知您。
                    </p>
                    <el-button type="primary" @click="gotoOrder" style="margin-top:50px;margin-bottom:30px;width:200px">我的订单</el-button>
                </div>
            </el-card>
        </div>
        
    </div>
</template>
<script>
export default {
    methods:{
        gotoOrder(){
            this.$router.push('/order')
        }
    }
}
</script>
